import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';

export function Introduction() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50 flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-3xl w-full bg-white rounded-xl shadow-lg p-8 space-y-6 text-center">
        <h1 className="text-4xl font-bold text-[#004060]">Welcome to the Freelie App</h1>
        <p className="text-xl text-gray-700">
          Jump to your freedom and success. And there are only three main steps:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6 text-left">
          <div className="p-4 border rounded-lg bg-blue-50">
            <h3 className="text-lg font-semibold text-[#004060]">📝 Clarify</h3>
            <p className="text-sm text-gray-700 mt-1">
              Reflect on your goals, values, and the fears standing in your way.
            </p>
          </div>
          <div className="p-4 border rounded-lg bg-blue-50">
            <h3 className="text-lg font-semibold text-[#004060]">🚀 Act</h3>
            <p className="text-sm text-gray-700 mt-1">
              Choose meaningful, values-aligned actions each day to move forward with intention.
            </p>
          </div>
          <div className="p-4 border rounded-lg bg-blue-50">
            <h3 className="text-lg font-semibold text-[#004060]">🎉 Learn</h3>
            <p className="text-sm text-gray-700 mt-1">
              Celebrate your efforts, harness your insights, and build confidence.
            </p>
          </div>
        </div>

        <div className="mt-6 space-y-2">
          <h2 className="text-2xl font-bold text-[#004060]">The 10 for 10 Plan</h2>
          <p className="text-lg text-gray-700">
            Start with a <strong>10-day free trial</strong>. No credit card required.  
            <br />
            Then continue for just <strong>$10/month</strong>.
          </p>
        </div>

        <div className="mt-6">
          <Button onClick={() => navigate('/registration')} className="w-full">
            Start My Free Trial
          </Button>
        </div>
      </div>
    </div>
  );
}